import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=3f22f473&scoped=true&"
import script from "./Allocation.vue?vue&type=script&lang=js&"
export * from "./Allocation.vue?vue&type=script&lang=js&"
import style1 from "./Allocation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22f473",
  null
  
)

export default component.exports